"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Patient = exports.PatientEvent = exports.Injury = exports.InjurySection = exports.ETA = void 0;
var cerealParse_1 = require("../cerealParse");
var client_1 = require("./client");
var message_1 = require("./message");
var job_1 = require("./job");
var hospital_1 = require("./hospital");
var functions_1 = require("../utils/functions");
var ETA = /** @class */ (function () {
    function ETA(projectedEta, initial, type) {
        this.projectedEta = projectedEta;
        this.initial = initial;
        this.type = type;
    }
    ETA.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ETA(new Date(cerealParse_1.ParseUtils.getNumber(o, 'projectedEta') * 1000), cerealParse_1.ParseUtils.getNumberOrNull(o, 'initial'), cerealParse_1.ParseUtils.getString(o, 'type')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid HAResponder Model: ".concat(e.message));
        }
    };
    return ETA;
}());
exports.ETA = ETA;
var InjurySection = /** @class */ (function () {
    function InjurySection(header, inputType, selected) {
        this.header = header;
        this.inputType = inputType;
        this.selected = selected;
    }
    InjurySection.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new InjurySection(cerealParse_1.ParseUtils.getString(o, 'header'), cerealParse_1.ParseUtils.getString(o, 'inputType'), cerealParse_1.ParseUtils.getArray(o, 'selected')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid InjurySection Model: ".concat(e.message));
        }
    };
    return InjurySection;
}());
exports.InjurySection = InjurySection;
var Injury = /** @class */ (function () {
    function Injury(type, sections) {
        this.type = type;
        this.sections = sections;
    }
    Injury.prototype.getFriendlyType = function () {
        switch (this.type) {
            case 'stroke':
                return 'Strong';
            case 'mi':
                return 'MI';
            case 'fall':
                return 'Fall';
            case 'sepsis':
                return 'Sepsis';
            case 'mvc':
                return 'MVC';
            case 'burnBlast':
                return 'Burn / Blast';
            case 'shooting':
                return 'Shooting';
            case 'stabbing':
                return 'Stabbing';
            case 'shootingStabbing':
                // Deprecated
                return 'Shooting / Stabbing';
            case 'stemi':
                return 'STEMI';
            case 'other':
                return 'Other';
            default:
                return this.type;
        }
    };
    Injury.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Injury(cerealParse_1.ParseUtils.getString(o, 'type'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'sections', InjurySection.parse, 'throw')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Injury Model: ".concat(e.message));
        }
    };
    return Injury;
}());
exports.Injury = Injury;
var PatientEvent = /** @class */ (function () {
    function PatientEvent(id, ts, initiator, type) {
        this.id = id;
        this.ts = ts;
        this.initiator = initiator;
        this.type = type;
    }
    PatientEvent.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new PatientEvent(cerealParse_1.ParseUtils.getString(o, 'id'), new Date(cerealParse_1.ParseUtils.getNumber(o, 'ts') * 1000), cerealParse_1.ParseUtils.getSubobject(o, 'initiator', client_1.MinimalClient.parse), cerealParse_1.ParseUtils.getString(o, 'type')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid PatientEvent Model: ".concat(e.message));
        }
    };
    return PatientEvent;
}());
exports.PatientEvent = PatientEvent;
var Patient = /** @class */ (function () {
    function Patient(id, age, callback, color, eta, hospital, injuries, job, patientNumber, rigId, sex, status, events, timeline) {
        this.id = id;
        this.age = age;
        this.callback = callback;
        this.color = color;
        this.eta = eta;
        this.hospital = hospital;
        this.injuries = injuries;
        this.job = job;
        this.patientNumber = patientNumber;
        this.rigId = rigId;
        this.sex = sex;
        this.status = status;
        this.events = events;
        this.timeline = timeline;
    }
    Patient.prototype.getFormattedSex = function () {
        return (0, functions_1.toTitleCase)(this.sex);
    };
    Patient.prototype.getShortSex = function () {
        switch (this.sex) {
            case 'male':
                return 'M';
            case 'female':
                return 'F';
            case 'unknown':
                return '?';
        }
    };
    Patient.prototype.getInjuryOverview = function () {
        if (
        // One injury
        this.injuries.length == 1 &&
            // Injury is type "Other"
            this.injuries[0].type == 'Other' &&
            // There is at least one "Extra" item in the section
            this.injuries[0].sections[0].selected.length != 0) {
            return this.injuries[0].sections[0].selected.join(', ');
        }
        else {
            return this.injuries.map(function (injury) {
                return injury.type;
            }).join(', ');
        }
    };
    Patient.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Patient(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getNumber(o, 'age'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'callback', job_1.HAResponder.parse), cerealParse_1.ParseUtils.getString(o, 'color'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'eta', ETA.parse), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'hospital', hospital_1.MinimalHospital.parse), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'injuries', Injury.parse, 'throw'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'job', job_1.HAJob.parse), cerealParse_1.ParseUtils.getNumber(o, 'number'), cerealParse_1.ParseUtils.getStringOrNull(o, 'rigId'), cerealParse_1.ParseUtils.getString(o, 'sex'), cerealParse_1.ParseUtils.getString(o, 'status'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'events', PatientEvent.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'timeline', message_1.Message.parse, 'throw')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Patient Model: ".concat(e.message));
        }
    };
    return Patient;
}());
exports.Patient = Patient;
//# sourceMappingURL=patient.js.map